import { z } from 'zod/v4';

export const AssemblyWideDriverCountPatchRuntype = z.object({
    driver_count: z.number(),
});

export const AssemblyWideDriverCountBulkPatchRuntype = z.object({
    /**
     * Map keyed by sourcing scenario UUID. `null` clears the scenario's
     * override. All entries are applied to the single `(assembly, driver)`
     * row in one read-modify-write on the backend, so the FE must collapse
     * what used to be N parallel per-scenario PATCHes into a single call.
     */
    scenario_counts: z.record(z.string(), z.number().nullable()),
});
